import toCamelCase from '../string/toCamelCase';

export interface ObjectKeysToCamelCaseOptions {
    recursive?: boolean;
    modifyInputObject?: boolean;
}

const defaultOptions: ObjectKeysToCamelCaseOptions = {
    recursive: true,
    modifyInputObject: true,
};

const keysToCamelCase = (input: object, options) => {
    options = { ...defaultOptions, ...options };

    const output: object | [] = options.modifyInputObject ? input : Array.isArray(input) ? [] : {};

    Object.keys(input).forEach(key => {
        const value = input[key];
        const newKey = toCamelCase(key);
        output[newKey] =
            options.recursive && !!value && typeof value === 'object' ? keysToCamelCase(value, options) : value;
        if (key !== newKey) {
            delete output[key];
        }
    });

    return output;
};

export default <InputType extends object, ReturnType extends object = Record<string, any>>(
    input: InputType,
    options = defaultOptions,
) => keysToCamelCase(input, options) as ReturnType;
